import React from 'react'
import { Route } from 'react-router-dom'
import UserNav from '../Pages/User/UserNav'
import NoMatch from '../Pages/NoMatch/NoMatch'
import { shallowEqual, useSelector } from 'react-redux'
import { getUserData } from '../entity/user/model/selector/getUserData/getUserData'

const AdminRoute = ({ component: Component, ...rest }) => {
  const user = useSelector(getUserData, shallowEqual)

  return (
    <Route
      {...rest}
      render={props =>
        user?.role === 'user' ? (
          <>
            <UserNav />
            <div className='dashboard-component'>
              <Component {...props} />
            </div>
          </>
        ) : (
          <NoMatch />
        )
      }
    />
  )
}

export default AdminRoute
